import axios, { AxiosResponse } from "axios";
import { NotificationDTO } from "../../models/dtos/profile/NotificationDTO";
import BaseService from "../base/BaseService";

export default class NotificationService extends BaseService {
    getNotification(): Promise<NotificationDTO[]> {
        return axios.get( `/Notification/ReceiveMyNotifications`)
            .then(function (response: AxiosResponse<NotificationDTO[]>) {
                return response.data;
            });
    }

    readNotification(ids:any):Promise<any> {
        return axios.post( `Notification/ReadNotification`, ids)
            .then(function (response) {
                return response
            });
    }
}